export function intersperse<T>(
    separator: T | string,
    array: Array<T>
): Array<T | string> {
    return array.reduce(
        (accumulator: Array<T | string>, next: T, index: number) => {
            accumulator.push(next);
            if (index !== array.length - 1) {
                accumulator.push(separator);
            }
            return accumulator;
        },
        []
    );
}
